import { GraphQLClient } from "graphql-request";

const endpoint = `${window.location.origin}/graphql`;

export const graphqlClient = new GraphQLClient(endpoint, {
  headers: () => {
    const token = localStorage.getItem("auth_token");
    const headers: Record<string, string> = {};
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return headers;
  },
});
